import BannerOtimizeNegocio from "../../components/banner-otimize-negocio";
import BannerProjects from "../../components/bannerProjects";
import ObjetivosEstrategicos from "../../components/objetivosEstrategicos";
import Programa from "../../components/Programa";
import Rodape from "../../components/rodape";

export default function NewTechs() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/banner-new-techs.png"
                bgMobile="../assets/banner-new-techs-mobile.png"
                title="/ESTRATÉGIA"
                titleBold="NEW TECHS"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description={
                    <>
                        <span className="font-bold">
                            Conectamos seu negócio aos talentos do futuro.{" "}
                        </span>
                        Formamos e desenvolvemos novos profissionais em
                        tecnologia — estudantes e talentos em formação prontos
                        para crescer junto com o seu negócio. Uma oportunidade
                        única de integrar à sua equipe mentes criativas,
                        atualizadas e cheias de vontade de inovar.
                    </>
                }
                footerText="VERTICAL PROJECTS | Development"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <ObjetivosEstrategicos />
            <BannerOtimizeNegocio
                headingBold="Conectamos inovação e tecnologia "
                headingText="para construir soluções, transformar negócios e inspirar pessoas."
                buttonText="Otimize seu negócio!"
                buttonUrl="/"
            />
            <Programa />
            <Rodape />
        </>
    );
}
